module.exports = __webpack_public_path__ + "img/delete.bde378b7.svg";